module.exports = __webpack_public_path__ + "static/media/Group 843.fe650a94.svg";